// NIGHT-DIRECTSTAFF-2026-10-28 §4: staff roles without SQL -- the owner's Staff list (public.staff_list(): email + role, nothing
// else) and the role change (public.staff_set_role(email, role): owner only, logged on the activity log, never the last owner).
// Both from tools/sql/2026-10-28-staff-set-role.sql; before the hub applies it the list is { ready: false } and nothing is shown.
export const ROLE_LABELS = { owner: 'Owner', recruiter: 'Recruiter' };
export const ROLE_WORDS = {
  owner: 'everything, and sets roles',
  recruiter: 'everything but merge, Mark as test, the bulk actions, Settings and Export',
};
export const STAFF_ERRORS = {
  'staff:owner_only': 'Only an owner can change roles.',
  'staff:last_owner': 'At least one owner has to stay: make someone else an owner first.',
  'staff:not_found': 'That account is not on the staff list.',
  'staff:bad_role': 'Pick Owner or Recruiter.',
};
const missingFn = (e) => !!e && (/PGRST202|42883/.test(String(e.code || '')) || /could not find the function/i.test(String(e.message || '')));
const words = (e) => { const code = (/staff:[a-z_]+/.exec(String((e && e.message) || '')) || [])[0]; return STAFF_ERRORS[code] || (e && e.message) || 'Not saved'; };

export function makeStaffApi(supabase) {
  return {
    /** -> { ready:false } before the migration; { ready:true, rows:[{ email, role }] } */
    async list() {
      const { data, error } = await supabase.rpc('staff_list');
      if (error) { if (missingFn(error)) return { ready: false }; throw new Error(words(error)); }
      return { ready: true, rows: (data || []).map((r) => ({ email: String(r.email || ''), role: r.role === 'recruiter' ? 'recruiter' : 'owner' })) };
    },
    async setRole(email, role) {
      const { data, error } = await supabase.rpc('staff_set_role', { p_email: email, p_role: role });
      if (error) throw new Error(words(error));
      return data;
    },
  };
}
